const state = {
	current_theme_color : localStorage.getItem('current_theme_color') ? localStorage.getItem('current_theme_color') : null,
	colors : ['#F72585', '#B5179E', '#7209B7', '#560BAD', '#480CA8', '#3A0CA3', '#3F37C9', '#4361EE', '#4895EF', '#4CC9F0'],
	user_cards : [{
		name : 'Subjects',
		description : 'Manage your subjects',
		styles : {
			card_color : 'rgb(255 95 161)'
		},
		img : require('@/assets/images/App/subject.svg'),
		router_name : 'subject'
	},
	{
		name : 'Grades',
		description : 'Manage your grades',
		styles : {
			card_color : 'rgb(65 255 20)'
		},
		img : require('@/assets/images/App/grade.svg'),
		router_name : 'grade'
	},
	{
		name : 'Grade Subjects',
		description : 'Manage grade-subject mapping',
		styles : {
			card_color : 'rgb(117 191 255)'
		},
		img : require('@/assets/images/App/mapping.svg'),
		router_name : 'gradesubject'
	},
	{
		name : 'Clipart Library',
		description : 'Manage clipart for questions',
		styles : {
			card_color : 'rgb(255 166 132)'
		},
		img : require('@/assets/images/App/clipart.svg'),
		router_name : 'clipart'
	},
	
			// {
			// 	name : 'Question Banks',
			// 	description : 'Manage your question banks',
			// 	styles : {
			// 		card_color : 'rgb(241 255 125)'
			// 	},
			// 	img : require('@/assets/images/App/questionbank.svg'),
			// 	router_name : 'questionbank'
			// },
			// {
			// 	name : 'Quizzes',
			// 	description : 'Manage your quizzes', 
			// 	styles : {
			// 		card_color : '#bcffff'
			// 	},
			// 	img : require('@/assets/images/App/quiz.svg'),
			// 	router_name : 'quiz'
			// },
			// {
			// 	name : 'ToDos / Notes',
			// 	description : 'Your Notes/ToDo List planner', 
			// 	styles : {
			// 		card_color : '#bcffff'
			// 	},
			// 	img : require('@/assets/images/App/todo.svg'),
			// 	router_name : 'todo'
			// },
	],

	administrator_cards : [{
		name : 'Subjects',
		description : 'Manage your subjects',
		styles : {
			card_color : 'rgb(255 95 161)'
		},
		img : require('@/assets/images/App/subject.svg'),
		router_name : 'subject'
	},
	{
		name : 'Grades',
		description : 'Manage your grades',
		styles : {
			card_color : 'rgb(65 255 20)'
		},
		img : require('@/assets/images/App/grade.svg'),
		router_name : 'grade'
	},
	{
		name : 'Grade Subjects',
		description : 'Manage grade-subject mapping',
		styles : {
			card_color : 'rgb(117 191 255)'
		},
		img : require('@/assets/images/App/mapping.svg'),
		router_name : 'gradesubject'
	},
	{
		name : 'Clipart Library',
		description : 'Manage clipart for questions',
		styles : {
			card_color : 'rgb(255 166 132)'
		},
		img : require('@/assets/images/App/clipart.svg'),
		router_name : 'clipart'
	},
	{
		name : 'Picture Library',
		description : 'Manage pictures for questions',
		styles : {
			card_color : 'rgb(255 166 132)'
		},
		img : require('@/assets/images/App/clipart.svg'),
		router_name : 'picturelibrary'
	},
	{
		name : 'Users',
		description : 'Manage users & payments',
		styles : {
			card_color : 'rgb(255 166 132)'
		},
		img : require('@/assets/images/App/users.svg'),
		router_name : 'user'
	},
	{
		name : 'Pending Explanations',
		description : 'Review questions requiring explanations',
		styles : {
			card_color : 'rgb(255 193 7)'
		},
		img : require('@/assets/images/App/questionbank.svg'),
		router_name : 'pending-explanations'
	}]

}

const getters = {
	fetchColors : (state) => state.colors,
	fetchMenu : (state) => state.user_cards,
	fetchAdministratorMenu : (state) => state.administrator_cards,
	fetchCurrentThemeColor : (state) => state.current_theme_color
}

const actions = {
	updateThemeColor({commit}, color){
		commit('SET_CURRENT_THEME_COLOR', color)
	}
}

const mutations = {
	SET_CURRENT_THEME_COLOR : (state, color) => {
		state.current_theme_color = color
		localStorage.setItem('current_theme_color', color)
	}
}

export default {
	state, getters, actions, mutations
}